import NotFoundImage from '@assets/general/404/404Page.svg';
import { Box } from '@mui/system';
import getDarkTheme from 'constants/Theme/DarkTheme';
import React from 'react';

const NotFoundPage: React.FC = () => {
	const message = intl.tr('pages.notFound.message');

	return (
		<Box
			display="flex"
			flexGrow={1}
			justifyContent="center"
			alignItems="center"
			title={message}
			sx={{
				background: getDarkTheme().palette.background.default
			}}
		>
			<img
				src={NotFoundImage}
				alt={message}
				height="100%"
				width="auto"
				loading="lazy"
				style={{ maxWidth: '100%' }}
			/>
		</Box>
	);
};

export default NotFoundPage;
